import { useMutation } from '@tanstack/react-query';
import { SelfServiceSessionService } from '../../generated';

interface InitialInstructionProps {
  jobsiteId: string;
  sessionId: string;
  lang: string;
}

export function useRequestInitialInstruction() {
  return useMutation({
    mutationFn: async ({ jobsiteId, sessionId, lang }: InitialInstructionProps) => {
      const response = await SelfServiceSessionService.selfServiceSessionControllerRequestInitialInstruction({
        path: {
          jobsiteId,
          sessionId,
          lang,
        },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (
          (response as any).error ||
          new Error(response?.response?.statusText || 'Unknown error when requesting initial instruction')
        );
      }
    },
  });
}
